import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'
import VueLoading from 'vue-loading-overlay';
import notifications from 'vue-notification';
import NProgress from 'nprogress';
import App from './App.vue';
import router from './router';
import 'bootstrap';
import store from './store';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'nprogress/nprogress.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import clipboard from 'clipboard';
import ModalPlugin from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(notifications);
Vue.use(VueLoading); // 之後做驗證
Vue.use(ModalPlugin)
Vue.config.productionTip = false;
Vue.prototype.clipboard = clipboard;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
NProgress.configure({
  showSpinner: false,
});
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.meta.requiresAuth) {
    // console.log('localStorage', localStorage.token);
    if (localStorage.token) {
      next();
      NProgress.done();
    } else {
      // alert('請先登入');
      next({
        path: '/login',
      });
      NProgress.done();
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  NProgress.done(); // 結束Progress
});
